import { useState, useEffect } from 'react';
import { Rocket } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 p-2 bg-primary text-primary-foreground rounded-full shadow-lg hover:bg-primary/90 hover-scale transition-all duration-300 animate-fade-in"
          aria-label="Scroll to top"
        >
          <Rocket size={18} />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
